//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Builder.js";
import "../no/Expression.js";
import "../no/Expression.js";
let d=[[[0,"CenterPoint",1,"Point",0],[0,"CreateConstraint",1,0],[1,"LengthDimension",0,"Expression",0],[0,"NumberOfSides",1,0],[1,"RadiusDimension",0,"Expression",0],[1,"RotationDimension",0,"Expression",0],[0,"Size",1,0],[0,"SizePoint",1,"Point",0]],[[["createDim"],"CreateLengthDimension",{},1,0],[["createDim"],"CreateRadiusDimension",{},1,0],[["createDim"],"CreateAngleDimension",{},1,0]],[]];
SPLM.SketchPolygonBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.SketchPolygonBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.SketchPolygonBuilder.SizeType = Object.freeze({
    "InscribedRadius" : "InscribedRadius", "CircumscribedRadius" : "CircumscribedRadius", "SideLength" : "SideLength"});

export default SPLM;